'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CASE_LABELS = _constants.AppConstants.CASE_LABELS;


var DEFAULT_COLOR = 'blue',
    SPECIFIC_COLORS = {
  closed_full_payment: 'green',
  closed_no_recovery: 'red',
  closed_partial_loss: 'red',
  closed_reduced_payment: 'green',
  potential_loss: 'red'
};

var CaseLabel = (_temp = _class = function (_Component) {
  _inherits(CaseLabel, _Component);

  function CaseLabel() {
    _classCallCheck(this, CaseLabel);

    return _possibleConstructorReturn(this, (CaseLabel.__proto__ || Object.getPrototypeOf(CaseLabel)).apply(this, arguments));
  }

  _createClass(CaseLabel, [{
    key: 'getColor',
    value: function getColor() {
      return SPECIFIC_COLORS[this.props.status] || DEFAULT_COLOR;
    }
  }, {
    key: 'render',
    value: function render() {
      var status = this.props.status;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('tracking-status', 'text-' + this.getColor()) },
        CASE_LABELS[status]
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseLabel;
}(_react.Component), _class.propTypes = {
  status: _propTypes2.default.string
}, _temp);
var _default = CaseLabel;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CASE_LABELS, 'CASE_LABELS', '/app/src/components/page-case/CaseLabel.js');
  reactHotLoader.register(DEFAULT_COLOR, 'DEFAULT_COLOR', '/app/src/components/page-case/CaseLabel.js');
  reactHotLoader.register(SPECIFIC_COLORS, 'SPECIFIC_COLORS', '/app/src/components/page-case/CaseLabel.js');
  reactHotLoader.register(CaseLabel, 'CaseLabel', '/app/src/components/page-case/CaseLabel.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/CaseLabel.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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